import { AddEditDeliveryChallan, AddEditGSTInvoiceFinishGoods, AddEditInvoicePM, AddEditInvoiceRM, AddEditInwardPost, AddEditOutwardPost, AddEditSalesGoodsReturnEntry, AddEditSalesOrderEntry, CancelEInvoiceById, DeleteInvoiceById, DeleteInwardPostById, DeleteItemDeliveryChallanById, DeleteItemFromDBById, DeleteOtherDeliveryChallanById, DeleteOutwardPostById, DeletePMInvoiceById, DeletePMItemFromDBById, DeleteRMInvoiceById, DeleteRMItemFromDBById, DeleteSalesGoodsReturnById, DeleteSalesGoodsReturnItemById, DeleteSalesOrderById, DeleteSalesOrderItemByItemId, GenerateEInvoiceById, GenerateEwayBill, GenerateGSTInvoiceForFinishGoodsById, GetAllBatchesForItemByItemId, GetAllBatchWiseStockStatementReport, GetAllGSTInvoiceFinishGoodsRecords, GetAllGSTInvoicePMRecords, GetAllGSTInvoiceRMRecords, GetAllInwardOutwardRegister, GetAllInwardPost, GetAllItemWiseDesptach, GetALLItemWiseMonthlySales, GetAllNearExpiryStockReport, GetAllOrderDetailsItemMappingById, GetallOtherDeliveryChallanList, GetAllOutwardPost, GetAllPartyWiseDespatchItem, GetAllPartyWiseDespatchItemById, GetAllPartyWiseMonthlySalesByPartyId, GetAllSalesGoodsReturnEntry, GetAllSalesOrderEntry, UpdateSalesOrderProforma, GetAllStockLedgerReport, GetAllStockLedgerReportBatchStock, GetALLStockStatementByProductId, GetAllStockStatementReport, GetCompanyAddressByCompanyId, GetGSTInvoiceFinishGoodsById, GetGSTInvoiceFinishGoodsInvoiceNo, GetGSTInvoicePMById, GetGSTInvoicePMInvoiceNo, GetGSTInvoiceRMById, GetGSTInvoiceRMInvoice, GetInwardPostById, GetOtherDeliveryChallanDetailsById, GetOutwardPostById, GetPakcingMaterialStockByPMID, GetProductionStockByProductId, GetrawMaterialStockByRMId, GetSalesGoodsReturnDetailsById, GetSalesGoodsReturnEntryInvoiceNo, GetSerialNoForDeliveryChallan, SendGSTInvoiceFinishGoodsToClient, SendGSTInvoicePMToClient, SendGSTInvoiceRMToClient } from "../ApiEndPoints.js";
import { axiosGetMultiParams, axiosGetWithencryption, axiosPostWithencryption } from "../AxiosRequests.js";

export default class DespatchServices {

    // GST Invoice Receive Goods
    async getProductionStockByProductId(request) {
        return axiosGetWithencryption(GetProductionStockByProductId, request);
    }

    async getGSTInvoiceFinishGoodsInvoiceNo(request) {
        return axiosGetWithencryption(GetGSTInvoiceFinishGoodsInvoiceNo, request);
    }

    async addEditGSTInvoiceFinishGoods(request) {
        return axiosPostWithencryption(AddEditGSTInvoiceFinishGoods, request);
    }

    async getAllGSTInvoiceFinishGoodsRecords(request) {
        return axiosPostWithencryption(GetAllGSTInvoiceFinishGoodsRecords, request);
    }

    async getGSTInvoiceFinishGoodsById(request) {
        return axiosGetWithencryption(GetGSTInvoiceFinishGoodsById, request);
    }

    async deleteItemFromDBById(request) {
        return axiosPostWithencryption(DeleteItemFromDBById, request);
    }

    async deleteInvoiceById(request) {
        return axiosGetWithencryption(DeleteInvoiceById, request);
    }

    async generateGSTInvoiceForFinishGoodsById(request) {
        return axiosGetWithencryption(GenerateGSTInvoiceForFinishGoodsById, request);
    }

    async sendGSTInvoiceFinishGoodsToClient(request) {
        return axiosGetWithencryption(SendGSTInvoiceFinishGoodsToClient, request);
    }

    async generateEInvoiceById(request) {
        return axiosGetWithencryption(GenerateEInvoiceById, request);
    }

    async generateEwayBill(request) {
        return axiosPostWithencryption(GenerateEwayBill, request);
    }

    async cancelEInvoiceById(request) {
        return axiosPostWithencryption(CancelEInvoiceById, request);
    }

    // GST Invoice RM
    async getGSTInvoiceRMInvoice(request) {
        return axiosGetWithencryption(GetGSTInvoiceRMInvoice, request);
    }

    async getrawMaterialStockByRMId(request) {
        return axiosPostWithencryption(GetrawMaterialStockByRMId, request);
    }

    async addEditInvoiceRM(request) {
        return axiosPostWithencryption(AddEditInvoiceRM, request);
    }

    async getAllGSTInvoiceRMRecords(request) {
        return axiosPostWithencryption(GetAllGSTInvoiceRMRecords, request);
    }

    async getGSTInvoiceRMById(request) {
        return axiosGetWithencryption(GetGSTInvoiceRMById, request);
    }

    async deleteRMItemFromDBById(request) {
        return axiosPostWithencryption(DeleteRMItemFromDBById, request);
    }

    async deleteRMInvoiceById(request) {
        return axiosGetWithencryption(DeleteRMInvoiceById, request);
    }

    async sendGSTInvoiceRMToClient(request) {
        return axiosGetWithencryption(SendGSTInvoiceRMToClient, request);
    }

    // GST Invoice PM
    async getGSTInvoicePMInvoiceNo(request) {
        return axiosGetWithencryption(GetGSTInvoicePMInvoiceNo, request);
    }

    async getPakcingMaterialStockByPMID(request) {
        return axiosPostWithencryption(GetPakcingMaterialStockByPMID, request);
    }

    async addEditInvoicePM(request) {
        return axiosPostWithencryption(AddEditInvoicePM, request);
    }

    async getAllGSTInvoicePMRecords(request) {
        return axiosPostWithencryption(GetAllGSTInvoicePMRecords, request);
    }

    async getGSTInvoicePMById(request) {
        return axiosGetWithencryption(GetGSTInvoicePMById, request);
    }

    async deletePMItemFromDBById(request) {
        return axiosPostWithencryption(DeletePMItemFromDBById, request);
    }

    async deletePMInvoiceById(request) {
        return axiosGetWithencryption(DeletePMInvoiceById, request);
    }

    async sendGSTInvoicePMToClient(request) {
        return axiosGetWithencryption(SendGSTInvoicePMToClient, request);
    }

    // Sales Order Entry
    async addEditSalesOrderEntry(request) {
        return axiosPostWithencryption(AddEditSalesOrderEntry, request);
    }

    async getAllOrderDetailsItemMappingById(request) {
        return axiosGetWithencryption(GetAllOrderDetailsItemMappingById, request);
    }

    async getAllSalesOrderEntry(request) {
        return axiosPostWithencryption(GetAllSalesOrderEntry, request);
    }

    async updateSalesOrderProforma(request) {
        return axiosPostWithencryption(UpdateSalesOrderProforma, request);
    }

    async deleteSalesOrderById(request) {
        return axiosGetWithencryption(DeleteSalesOrderById, request);
    }

    async deleteSalesOrderItemByItemId(request) {
        return axiosGetWithencryption(DeleteSalesOrderItemByItemId, request);
    }

    // Sales Goods Return Entry
    async getAllBatchesForItemByItemId(request) {
        return axiosGetWithencryption(GetAllBatchesForItemByItemId, request);
    }

    async getSalesGoodsReturnEntryInvoiceNo(request) {
        return axiosGetWithencryption(GetSalesGoodsReturnEntryInvoiceNo, request);
    }

    async addEditSalesGoodsReturnEntry(request) {
        return axiosPostWithencryption(AddEditSalesGoodsReturnEntry, request);
    }

    async getAllSalesGoodsReturnEntry(request) {
        return axiosPostWithencryption(GetAllSalesGoodsReturnEntry, request);
    }

    async getSalesGoodsReturnDetailsById(request) {
        return axiosGetWithencryption(GetSalesGoodsReturnDetailsById, request);
    }

    async deleteSalesGoodsReturnItemById(request) {
        return axiosPostWithencryption(DeleteSalesGoodsReturnItemById, request);
    }

    async deleteSalesGoodsReturnById(request) {
        return axiosGetWithencryption(DeleteSalesGoodsReturnById, request);
    }

    // Other Delivery Challan
    async getSerialNoForDeliveryChallan(request) {
        return axiosGetWithencryption(GetSerialNoForDeliveryChallan, request);
    }

    async addEditDeliveryChallan(request) {
        return axiosPostWithencryption(AddEditDeliveryChallan, request);
    }

    async getallOtherDeliveryChallanList(request) {
        return axiosPostWithencryption(GetallOtherDeliveryChallanList, request);
    }

    async getOtherDeliveryChallanDetailsById(request) {
        return axiosGetWithencryption(GetOtherDeliveryChallanDetailsById, request);
    }

    async deleteItemDeliveryChallanById(request) {
        return axiosGetWithencryption(DeleteItemDeliveryChallanById, request);
    }

    async deleteOtherDeliveryChallanById(request) {
        return axiosGetWithencryption(DeleteOtherDeliveryChallanById, request);
    }

    // Envelope Print
    async getCompanyAddressByCompanyId(request) {
        return axiosGetWithencryption(GetCompanyAddressByCompanyId, request);
    }

    // Reports
    // Party Wise Despatch Report
    async getAllPartyWiseDespatchItem(request) {
        return axiosPostWithencryption(GetAllPartyWiseDespatchItem, request);
    }

    async getAllPartyWiseDespatchItemById(request) {
        return axiosGetWithencryption(GetAllPartyWiseDespatchItemById, request);
    }

    // Item Wise Despatch Report
    async getAllItemWiseDesptach(request) {
        return axiosPostWithencryption(GetAllItemWiseDesptach, request);
    }

    // Item Wise Monthly Sales
    async getALLItemWiseMonthlySales(request) {
        return axiosPostWithencryption(GetALLItemWiseMonthlySales, request);
    }

    // Party Wise Monthly Sales
    async getAllPartyWiseMonthlySalesByPartyId(request) {
        return axiosGetWithencryption(GetAllPartyWiseMonthlySalesByPartyId, request);
    }

    // Stock Statement Report
    async getAllStockStatementReport(request) {
        return axiosPostWithencryption(GetAllStockStatementReport, request);
    }

    async getALLStockStatementByProductId(request) {
        return axiosGetMultiParams(GetALLStockStatementByProductId, request);
    }

    async getAllBatchWiseStockStatementReport(request) {
        return axiosPostWithencryption(GetAllBatchWiseStockStatementReport, request);
    }

    // Stock Ledger Report
    async getAllStockLedgerReport(request) {
        return axiosPostWithencryption(GetAllStockLedgerReport, request);
    }

    async getAllStockLedgerReportBatchStock(request) {
        return axiosPostWithencryption(GetAllStockLedgerReportBatchStock, request);
    }

    // Near Expiry Stock Report
    async getAllNearExpiryStockReport(request) {
        return axiosPostWithencryption(GetAllNearExpiryStockReport, request);
    }

    //  Inward Post entry 
    async addEditInwardPost(request) {
        return axiosPostWithencryption(AddEditInwardPost, request);
    }
    async getAllInwardPost(request) {
        return axiosPostWithencryption(GetAllInwardPost, request);
    }
    async getInwardPostById(request) {
        return axiosGetWithencryption(GetInwardPostById, request);
    }
    async deleteInwardPostById(request) {
        return axiosGetWithencryption(DeleteInwardPostById, request);
    }
    //  Outward Post entry 
    async addEditOutwardPost(request) {
        return axiosPostWithencryption(AddEditOutwardPost, request);
    }
    async getAllOutwardPost(request) {
        return axiosPostWithencryption(GetAllOutwardPost, request);
    }
    async getOutwardPostById(request) {
        return axiosGetWithencryption(GetOutwardPostById, request);
    }
    async deleteOutwardPostById(request) {
        return axiosGetWithencryption(DeleteOutwardPostById, request);
    }
    // Inward Outward post register 
    async getAllInwardOutwardRegister(request) {
        return axiosPostWithencryption(GetAllInwardOutwardRegister, request);
    }

}

